import { useQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { orderServices } from '../..';

export const useGetPopularGifts = (params, options) => {
  const {
    filters: { associationType = '', ids = [] } = {},
    pagination: { limit = '', page = '' } = {}
  } = params;

  return useQuery(
    [`${associationType}PopularGifts`, associationType + ids + page + limit],
    () =>
      orderServices.getPopularGifts(
        cleanObjectEmptyFields({
          filters: {
            associationType,
            ids
          },
          pagination: {
            limit,
            page
          }
        })
      ),
    options
  );
};
